export const Constants = {
  version: 1,
};
export const ACCESS_TOKEN_LS_KEY='authToken'
